import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import {List} from 'immutable';
import _ from 'lodash';


export default class EmailMessageReply extends React.Component {

    static propTypes = {
        accountEmail: PropTypes.string.isRequired,
        thread: PropTypes.object.isRequired,
        uploadFile: PropTypes.func.isRequired,
        replyToMessage: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.editor = null;
        this.replyComposerElm = null;
        this.tinymceInitCalled = false;
        this.fileInputElm = null;

        this.onReplyClick = this.onReplyClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onAttachClick = this.onAttachClick.bind(this);
        this.onSendClick = this.onSendClick.bind(this);
        this.tinymceInitCallback = this.tinymceInitCallback.bind(this);
        this.onToEmailChange = this.onToEmailChange.bind(this);
        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.onFileRemoveClick = this.onFileRemoveClick.bind(this);

        let lastMessage = _.last(props.thread.messages);
        let _uniqueParticipants = _.chain(props.thread.participants).uniqBy('email');
        let possibleReplyTo = _.chain(lastMessage.to).map('email').concat(lastMessage.from[0].email).value();
        let participants = _uniqueParticipants.filter(contact => contact.email !== props.accountEmail).value();
        let from = _uniqueParticipants.find(_.matchesProperty('email', props.accountEmail)).value();
        let toEmail = (participants.find(contact => possibleReplyTo.includes(contact.email)) || participants[0]).email;

        this.state = {
            tinyMCEScriptLoaded: false,
            composeMode: false,
            from: from,
            toEmail: toEmail,
            participants: participants,
            files: [],
            uploadingFiles: new List(),
            tinymceInitialized: false,
            editorDisabled: false
        };
    }

    onReplyClick() {
        this.setState({
            composeMode: true
        });
    }

    onToEmailChange(event) {
        this.setState({
            toEmail: event.target.value
        });
    }

    onCancelClick() {
        this.destroyEditor();
        this.setState({
            composeMode: false,
            tinymceInitialized: false
        });
    }

    onAttachClick() {
        this.fileInputElm.click();
    }

    onFileInputChange() {
        if (this.fileInputElm.files.length === 0) {
            return;
        }
        let inputFile = this.fileInputElm.files[0];

        this.setState((prevState, props) => ({
            files: prevState.files.concat(inputFile)
        }));

/*
        this.setState((prevState, props) => ({
            editorDisabled: true,
            uploadingFiles: this.state.uploadingFiles.push(inputFile)
        }));

        this.props.uploadFile(inputFile).then(file => {
            this.fileInputElm.value = '';
            this.setState((prevState, props) => ({
                editorDisabled: false,
                files: prevState.files.concat(file),
                uploadingFiles: prevState.uploadingFiles.delete(prevState.uploadingFiles.indexOf(inputFile))
            }));
        }).catch(error => {
            this.fileInputElm.value = '';
            this.editor.notificationManager.open({
                type: 'error',
                text: error.message || error.toString()
            });
            this.setState((prevState, props) => ({
                editorDisabled: false,
                uploadingFiles: prevState.uploadingFiles.delete(prevState.uploadingFiles.indexOf(inputFile))
            }));
        });
*/
    }

    onFileRemoveClick(event) {
        let fileIndex = parseInt(event.currentTarget.dataset.fileIndex, 10);
        this.setState((prevState, props) => {
            let files = prevState.files.slice();
            files.splice(fileIndex, 1);
            return {
                files: files
            }
        });
    }

    onSendClick() {
        let messageId = _.last(this.props.thread.messages).id;
        let to = _.find(this.state.participants, ['email', this.state.toEmail]);
        let body = this.editor.getContent();
        let files = this.state.files.length > 0 ? this.state.files : undefined;

        this.setState({editorDisabled: true});

        this.props.replyToMessage(messageId, [this.state.from], [to], body, files).catch(error => {
            this.setState({
                editorDisabled: false
            });
            this.editor.notificationManager.open({
                type: 'error',
                text: error.message || error.toString()
            });
        });
    }

    destroyEditor() {
        this.editor.setContent('');
        this.editor.destroy();
    }

    componentDidMount() {
        this.loadTinyMCEScript().then(() => {
            this.setState({tinyMCEScriptLoaded: true});
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.replyComposerElm && this.state.tinyMCEScriptLoaded && !this.tinymceInitCalled) {
            this.tinymceInitCalled = true;
            this.initTinyMCE();
        }
        if (prevState.editorDisabled !== this.state.editorDisabled) {
            this.editor.setMode(this.state.editorDisabled ? 'readonly' : 'design');
        }
    }

    componentWillUnmount() {
        if (this.editor) {
            this.destroyEditor();
        }
    }

    loadTinyMCEScript() {
        let id = "tinymceScript";
        let src = "https://app.tasksharp.com/js/tinymce/tinymce.min.js";

        if (document.getElementById(id) !== null) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.id = id;
            script.type = "text/javascript";
            script.src = src;
            script.addEventListener('load', () => {
                resolve();
            });
            script.addEventListener('error', (err) => {
                reject(err);
            });

            let head = document.head || document.getElementsByTagName("head")[0];
            head.appendChild(script);
        });
    }

    initTinyMCE() {
        window.tinymce.init({
            target: this.replyComposerElm,
            // focus the editor when it renders
            auto_focus: 'emailMessageReplyComposer',
            theme: 'modern',
            init_instance_callback: this.tinymceInitCallback,
            menubar: 'edit format',
            // plugins needed for several toolbar button to work
            plugins: 'textcolor lists advlist link code fullscreen',
            toolbar: 'fontselect fontsizeselect styleselect | bold italic underline forecolor backcolor ' +
                     '| alignleft aligncenter alignright alignjustify bullist numlist outdent indent ' +
                     '| link code fullscreen | removeformat',
            fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
            // hide status bar
            statusbar: false,
            // hide "Powered by tinymce"
            branding: false,
            // use HTML4 schema as we will use the content for emails which should be as compatible as possible
            schema: 'html4',
            // tinymce wraps all root text nodes with <p> tags, change them to <div>
            forced_root_block: 'div'
        });
    }

    tinymceInitCallback(editor) {
        let lastMessage = _.last(this.props.thread.messages);
        let lastMessageDate = moment(lastMessage.timestamp).format('ddd, MMM D, YYYY [at] LT');
        let fromString = lastMessage.from[0].name + ' &lt;<a href="mailto:' + lastMessage.from[0].email + '" target="_blank">' + lastMessage.from[0].email + '</a>&gt;';
        let content = (
            '<br/>' +
            '<div class="quote">' +
                '<br/>' +
                `<div class="quote_from">On ${lastMessageDate}, ${fromString} wrote:</div>` +
                '<br/>' +
                '<blockquote class="quote_body" style="margin: 0; padding-left: 16px; border-left: 1px #cccccc solid;">' +
                    lastMessage.body +
                '</blockquote>' +
            '</div>'
        );

        this.editor = editor;
        this.editor.setContent(content);

        this.editor.on('Remove', () => {
            this.editor = null;
            this.replyComposerElm = null;
            this.tinymceInitCalled = false;
        });

        this.setState({
            tinymceInitialized: true
        });
    }

    renderReplyPlaceholder() {
        return (
            <div className="emailMessageReplyContainer">
                <div className="emailMessageReplyPlaceHolder" onClick={this.onReplyClick}>Click here to <span className="emailMessageReplyLink">Reply</span></div>
            </div>
        );
    }

    renderReplyToSelector() {
        return (
            <select name="replyTo" value={this.state.toEmail} onChange={this.onToEmailChange}>
                {this.state.participants.map(contact => <option key={contact.email} value={contact.email}>{contact.name} ({contact.email})</option>)}
            </select>
        );
    }

    renderFileList() {
        if (this.state.files.length === 0 && this.state.uploadingFiles.size === 0) {
            return null;
        }
        let fileItems = this.state.files.map((file, index) => {
            return (
                <li key={'file-' + index} className="attachedFileListItem">
                    <div className="attachedFileInfo">
                        <i className="fa fa-trash" onClick={this.onFileRemoveClick} data-file-index={index}/>
                        {file.name} ({Math.round(file.size / 1024)}KB)
                    </div>
                </li>
            );
        });
        let uploadingFiles = this.state.uploadingFiles.toJS().map((file, index) => {
            return (
                <li key={'uploadingFile-' + index} className="attachedFileListItem">
                    <div className="attachedFileInfo">
                        <i className="fa fa-spinner fa-pulse" data-file-index={index}/>
                        {file.name} ({Math.round(file.size / 1024)}KB)
                    </div>
                </li>
            );
        });
        return <ul className="attachedFileList">{fileItems.concat(uploadingFiles)}</ul>;
    }

    renderReplyCompose() {
        return (
            <div className="emailMessageReplyContainer" style={{"display": this.state.tinymceInitialized ? "block" : "none"}}>
                <div className="emailMessageReplyToSelector">To: {this.renderReplyToSelector()}</div>
                <div id="emailMessageReplyComposer" style={{height: 400}} ref={elm => {this.replyComposerElm = elm;}}/>
                {this.renderFileList()}
                <button type="button" className="emailMessageButton" onClick={this.onCancelClick} disabled={this.state.editorDisabled}><i className="fa fa-trash"/>Cancel</button>
                <button type="button" className="emailMessageButton" onClick={this.onAttachClick} disabled={this.state.editorDisabled}><i className="fa fa-paperclip"/>Attach files</button>
                <button type="button" className="emailMessageButton" onClick={this.onSendClick}  disabled={this.state.editorDisabled}><i className="fa fa-paper-plane"/>Send</button>
                <input type="file" style={{"display":"none"}} disabled={this.state.editorDisabled} onChange={this.onFileInputChange} ref={elm => {this.fileInputElm = elm;}} />
            </div>
        );
    }

    render() {
        let replyElement = this.state.composeMode ? this.renderReplyCompose() : this.renderReplyPlaceholder();
        return (
            <div className="emailMessageReply">
                <div className="emailMessageAvatar"/>
                {replyElement}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/EmailMessageReply.js